import { useMemo, useState } from 'react'
import { useQuery } from 'react-query'

import { QueryKeys } from '../../../../enums/queryKeys'
import { getIntercomArticles } from '../query-api'
import { Article } from '../types/article'

interface UseIntercomArticlesSearchResponse {
  articles: Article[]
  isLoading: boolean
  searchQuery: string | null
  setSearchQuery: (query: string | null) => void
}

export const useIntercomArticlesSearch = (): UseIntercomArticlesSearchResponse => {
  const [searchQuery, setSearchQuery] = useState<string | null>(null)

  const queryKey = useMemo(() => [QueryKeys.IntercomArticles, searchQuery], [searchQuery])

  const { data, isLoading } = useQuery(queryKey, () => getIntercomArticles(searchQuery ?? ''), {
    enabled: !!searchQuery,
  })

  return {
    articles: data?.data.articles ?? [],
    isLoading,
    searchQuery,
    setSearchQuery,
  }
}
